<template>
  <section
    class="component-c6d2ee83"
    resmed-component-name="info_25/75_icon-line_list_image"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': `${acf.layout['background-color']}`,
      'background-size': `${acf.layout['background-size']}`,
      'padding-top': acf.layout['padding-top'],
      'padding-bottom': acf.layout['padding-bottom'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div
          class="row"
          v-bind:class="{
            'align-items-center': acf.layout['align-items-center'] === 'center',
          }"
        >
          <div
            class="col-md-4 mb-6 mb-md-0"
            v-bind:class="{
              'order-md-2': acf.layout['placement-cols'] === 'right',
            }"
          >
            <div
              class="animation"
              v-if="acf.animation"
              v-bind:style="{ transform: acf['animation-scale'] }"
            >
              <animation
                v-bind:animation="JSON.parse(acf.animation)"
              ></animation>
            </div>

            <figure
              v-else
              v-bind:class="{ 'is-card-image': acf.layout['is-card-image'] }"
            >
              <img
                class="img-fluid"
                v-bind:src="acf.image.sizes.large"
                alt=""
              />
            </figure>
          </div>
          <div
            v-bind:class="{
              'col-md-8 pl-md-5':
                !acf.layout['placement-cols'] ||
                acf.layout['placement-cols'] === 'left',
              'col-md-8 col-lg-7 offset-lg-1 pr-md-5':
                acf.layout['placement-cols'] === 'right',
              'pt-md-2': acf.eyebrowicon.icon,
            }"
          >
            <eyebrow-icon
              v-if="acf.eyebrowicon.icon"
              v-bind:eyebrowicon="acf.eyebrowicon"
            ></eyebrow-icon>
            <h2
              v-html="acf.headline"
              v-bind:class="{ '-has-eyebrow': acf.eyebrow }"
            ></h2>
            <div v-if="acf.content" v-html="acf.content"></div>

            <dl v-if="acf['list']" class="pt-4">
              <template v-for="(item, index) in acf['list']">
                <dt>
                  <div class="numbers">
                    <span>{{ index + 1 }}</span>
                  </div>
                  <span>{{ item["item-dt"] }}</span>
                </dt>
                <dd>{{ item["item-dd"] }}</dd>
              </template>
            </dl>

            <ul v-if="acf['list-unordered']" class="pt-4">
              <li
                v-for="(list, index) in acf['list-unordered']"
                v-html="list.item"
              ></li>
            </ul>

            <div v-if="acf.cta.href" class="call-to-action mt-4">
              <a
                v-bind:href="acf.cta.href"
                v-bind:target="acf.cta.target"
                class="btn cta-pill filled-red icon right-arrow"
                >{{ acf.cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-c6d2ee83", // info_25/75_icon-line_list_image
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-c6d2ee83 {
  padding: 6rem 0;
  overflow: hidden;

  background-position: center center;
  background-repeat: no-repeat;
}

.component {
  h2 {
    position: relative;
    margin-bottom: 1rem;

    &.-has-eyebrow {
      @extend %eyebrow-left;
    }
  }

  dl {
    dt {
      @extend %body-normal-bold;

      > span {
        display: block;
        padding-left: 2.5rem;
      }
    }

    dd {
      padding-left: 2.5rem;
    }

    dd:not(:last-child) {
      border-bottom: 1px solid rgba($cc-resmed-dark-grey, 0.25);
      margin-bottom: 1.25rem;
      padding-bottom: 1.25rem;
    }

    .numbers {
      overflow: hidden;
      float: left;

      span {
        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 50%;
        width: 1.75rem;
        height: 1.75rem;

        text-align: center;
        border: 1px solid rgba($cc-resmed-dark-grey, 0.325);

        @extend %body-small;
      }
    }
  }

  ul {
    padding-left: 1.125rem;
    list-style-position: outside;

    li {
      &:not(:last-child) {
        border-bottom: 1px solid rgba($cc-resmed-dark-grey, 0.25);
        margin-bottom: 1.25rem;
        padding-bottom: 1.25rem;
      }
    }
  }

  figure {
    img {
      margin: 0 auto;
    }

    @media (max-width: 575px) {
      max-width: 320px;
      margin: 0 auto;
    }

    &.is-card-image {
      @media (max-width: 575px) {
        max-width: none;
        margin: 0 auto;
      }

      img {
        border-radius: 6px;
        box-shadow: 0 0rem 12px 6px rgba(0, 0, 0, 0.125);
        overflow: hidden;
      }
    }
  }
}
</style>